import React, { forwardRef, PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flexbox from '@/components/common/Flexbox';
export type ButtonType = 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'red' | 'custom' | 'icon';
interface Props extends ElementPropsWithRef<'button'> {
  buttonType: ButtonType;
  disableSize?: boolean;
  disableRadius?: boolean;
  isLoading?: boolean;
}
const Button = forwardRef<HTMLButtonElement, PropsWithChildren<Props>>(({
  children,
  disableSize,
  disableRadius,
  buttonType,
  className,
  type = 'button',
  isLoading,
  ...buttonProps
}, ref) => {
  return <Flexbox as={'button'} align={'center'} justify={'center'} className={clsx(className, 'active:bg-opacity-45', 'transition-opacity duration-500', !disableSize && ['text-fz4/body', 'h-11'], {
    'rounded-m': !disableRadius
  }, buttonType === 'primary' && 'text-white font-bold bg-primary active:opacity-80 disabled:bg-grey4', buttonType === 'secondary' && 'text-primary font-bold border border-primary active:opacity-80 disabled:opacity-30', buttonType === 'tertiary' && 'text-grey2 bg-grey6 active:opacity-80 disabled:opacity-30', buttonType === 'quaternary' && 'text-grey2 border border-grey5 active:opacity-80 disabled:opacity-30', buttonType === 'red' && 'text-white font-bold bg-red active:opacity-80 disabled:opacity-30', buttonType === 'icon' && 'text-grey1 font-bold active:opacity-80 disabled:opacity-30', buttonType === 'custom' && 'active:opacity-80 disabled:opacity-30')}
  // @ts-ignore
  ref={ref} type={type} {...buttonProps}>
        {isLoading ? <FontAwesomeIcon icon={faSpinner} className={'animate-spin w-4 h-[2.625rem]'} /> : children}
      </Flexbox>;
});
export default Button;
export const FontAwesomeButton: React.FC<{
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  icon: IconProp;
  className?: string;
  iconClassName?: string;
  withBorder?: boolean;
  withoutSize?: boolean;
  testId?: string;
}> = ({
  onClick,
  icon,
  className,
  iconClassName = 'w-4',
  withBorder,
  withoutSize,
  testId
}) => <Button data-test-id={testId} disableSize buttonType={'icon'} className={clsx(className, withoutSize ? undefined : 'w-8 h-8', {
  'border border-grey5 shadow-sm': withBorder
})} onClick={onClick} data-sentry-element="Button" data-sentry-component="FontAwesomeButton" data-sentry-source-file="Button.tsx">
    <FontAwesomeIcon icon={icon} className={iconClassName} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="Button.tsx" />
  </Button>;